import { ChangeDetectionStrategy, Component, Input, TemplateRef } from "@angular/core";
import { ɵNzTabBodyComponent } from "ng-zorro-antd/tabs";

@Component({
  selector: "[ui-tab-body]",
  exportAs: "uiTabBody",
  templateUrl: "./tab-body.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiTabBodyComponent extends ɵNzTabBodyComponent {
  @Input() public content: TemplateRef<void> | null = null;
  @Input() public active = false;
  @Input() public tabPaneAnimated = true;
  @Input() public forceRender = false;
}
